<div id="page-content" class="inicio" id="boletos">
  <div class="row">
    <div class="col-sm-10 col-sm-offset-1">
      <div class="row mb-40">
        <div class="col-lg-6 mt-30">
          <div class="input textarea caixa-pesquisa">
            <input [(ngModel)]="inputSearch" (keyup)="filter()" class="input-searchbox" type="text" placeholder="Pesquisar">
          </div>
        </div>
        <div class="col-lg-6 mt-30">
          <app-datepicker [initialDate]="initialDate" [finalDate]="finalDate" (filter)="setFilterData($event)"></app-datepicker>
        </div>
      </div>


      <div *ngIf="!loaded && !error" class="container-loading">
        <div class="btn btn-registrar loading"></div>
      </div>
      <div class="col-md-10 col-md-offset-1" *ngIf="error">
        <span class="error">Nenhuma informação disponível no momento</span>
        <span class="error">Tente novamente mais tarde</span>
      </div>
      <table id="master-detail-table-boletos" style="width: 100%"></table>
    </div>
  </div>
</div>

<app-modal-detail [showModal]="showModal" (eventClose)="eventClose()">
  <div class="modal-body">
    <div class="row">
      <div class="col-xs-12 col-sm-12" *ngIf="boleto && boleto.SacadoNome">
        <div class="form-group">
          <label for="" class="control-label">Nome do Cliente</label>
          <p>
            {{boleto.SacadoNome}}
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-6" *ngIf="boleto && boleto.NossoNumero">
        <div class="form-group">
          <label for="" class="control-label">Nosso Número</label>
          <p>
            {{boleto.NossoNumero}}
          </p>
        </div>
      </div>
      <div class="col-xs-12 col-sm-6" *ngIf="boleto && boleto.NumeroDocumento">
        <div class="form-group">
          <label for="" class="control-label">Número Documento</label>
          <p>
            {{boleto.NumeroDocumento}}
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-12" *ngIf="boleto && boleto.Endereco">
        <div class="form-group">
          <label for="" class="control-label">Endereço</label>
          <p>
            {{boleto.Endereco}}
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-4" *ngIf="boleto && boleto.Cidade">
        <div class="form-group">
          <label for="" class="control-label">Cidade</label>
          <p>
            {{boleto.Cidade}}
          </p>
        </div>
      </div>
      <div class="col-xs-12 col-sm-4" *ngIf="boleto && boleto.Estado">
        <div class="form-group">
          <label for="" class="control-label">Estado</label>
          <p>
            {{boleto.Estado}}
          </p>
        </div>
      </div>
      <div class="col-xs-12 col-sm-4" *ngIf="boleto && boleto.Cep">
        <div class="form-group">
          <label for="" class="control-label">Cep</label>
          <p>
            {{boleto.Cep}}
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-4" *ngIf="boleto && boleto.DataVencimento">
        <div class="form-group">
          <label for="" class="control-label">Data de Vencimento</label>
          <p>
            {{boleto.DataVencimento}}
          </p>
        </div>
      </div>
      <div class="col-xs-12 col-sm-4" *ngIf="boleto && boleto.Valor">
        <div class="form-group">
          <label for="" class="control-label">Valor</label>
          <p>
            {{boleto.Valor}}
          </p>
        </div>
      </div>
    </div>
  </div>
</app-modal-detail>
